<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 md10 offset-md1>
        <router-view/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {};
</script>

<style scoped>

</style>
